import {
  InputGroupCode,
  SeedInputCode,
} from '../../../../../utilities/helper/unitGenerator/unit.types';

type GetUnitLabelParams = {
  inputGroupCode: InputGroupCode | null;
  inputCode?: number | null;
};

export const getUnitLabel = ({
  inputGroupCode,
  inputCode,
}: GetUnitLabelParams): string => {
  // group logic
  switch (true) {
    case InputGroupCode.MACHINERY === inputGroupCode:
      return 'برحسب تعداد';

    case InputGroupCode.SEED === inputGroupCode &&
      inputCode === SeedInputCode.SEEDLING:
      return 'برحسب اصله';

    default:
      return 'برحسب تعداد بسته';
  }
};
